import React, { useState } from 'react';
import { Row, Col, Form, Button, Dropdown } from 'react-bootstrap';
import './AdminProfessionalInfo.css';

function BeauticianFields({ formData, updateField }) {

  const filterOptions = (options, searchTerm) => {
    if (!searchTerm) return options;
    return options.filter(option =>
      option.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };


  const CustomDropdown = ({
    title,
    field,
    options,
    selectedValue,
    onSelect,
    required = false,
    menuClassName = ''  // Add this new prop
  }) => {
    const [localSearchTerm, setLocalSearchTerm] = useState('');
    const [isOpen, setIsOpen] = useState(false);

    const filteredOptions = filterOptions(options, localSearchTerm);

    return (
      <div>
        <Dropdown
          className="mb-3"
          show={isOpen}
          onToggle={(isOpen) => setIsOpen(isOpen)}
        >
          <Dropdown.Toggle
            variant="light"
            className="language-select w-100 d-flex justify-content-between align-items-center"
            id={`dropdown-${field}`}
          >
            {selectedValue || `${title}${required ? ' *' : ''}`}
          </Dropdown.Toggle>
          <Dropdown.Menu className={`w-100 ${menuClassName}`} style={{ overflowY: 'hidden' }}>
            <div className="px-2 py-1">
              <Form.Control
                type="text"
                placeholder={`Search ${title.toLowerCase()}...`}
                value={localSearchTerm}
                onChange={(e) => setLocalSearchTerm(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                className="mb-2"
                autoFocus
              />
            </div>
            <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option) => (
                  <Dropdown.Item
                    key={option}
                    active={selectedValue === option}
                    onClick={() => {
                      onSelect(field, option);
                      setLocalSearchTerm('');
                      setIsOpen(false);
                    }}
                  >
                    {option}
                  </Dropdown.Item>
                ))
              ) : (
                <Dropdown.Item disabled>No matches found</Dropdown.Item>
              )}
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  };

  // Helper functions for multi-select fields
  const toggleHennaServices = (service) => {
    const updated = formData.henna_services?.includes(service)
      ? formData.henna_services.filter(item => item !== service)
      : [...(formData.henna_services || []), service];
    updateField('henna_services', updated);
  };

  const toggleMakeupServices = (service) => {
    const updated = formData.makeup_services?.includes(service)
      ? formData.makeup_services.filter(item => item !== service)
      : [...(formData.makeup_services || []), service];
    updateField('makeup_services', updated);
  };

  const toggleSkinCareServices = (service) => {
    const updated = formData.skin_care_services?.includes(service)
      ? formData.skin_care_services.filter(item => item !== service)
      : [...(formData.skin_care_services || []), service];
    updateField('skin_care_services', updated);
  };

  const toggleNailServices = (service) => {
    const updated = formData.nail_services?.includes(service)
      ? formData.nail_services.filter(item => item !== service)
      : [...(formData.nail_services || []), service];
    updateField('nail_services', updated);
  };

  const toggleHairServices = (service) => {
    const updated = formData.hair_services?.includes(service)
      ? formData.hair_services.filter(item => item !== service)
      : [...(formData.hair_services || []), service];
    updateField('hair_services', updated);
  };

  const toggleMassageSpaServices = (service) => {
    const updated = formData.massage_spa_services?.includes(service)
      ? formData.massage_spa_services.filter(item => item !== service)
      : [...(formData.massage_spa_services || []), service];
    updateField('massage_spa_services', updated);
  };

  const toggleOtherTrendingServices = (service) => {
    const updated = formData.other_trending_services?.includes(service)
      ? formData.other_trending_services.filter(item => item !== service)
      : [...(formData.other_trending_services || []), service];
    updateField('other_trending_services', updated);
  };

  // Beautician mode options
  const beauticianModes = ["For Home", "For Parlour", "Both"];

  // Beautician type/specialization options - first 3 in buttons, rest in dropdown
  const beauticianSpecializationsMain = ["Makeup Artist", "Hair Stylist", "Henna Artist"];
  const beauticianSpecializationsAdditional = [
    "Manicure / Pedicure Specialist", "Facial / Skin Specialist", "Massage Therapist",
    "Nail Artist", "Eyelash / Eyebrow Specialist", "Spa Therapist"
  ];

  // Henna services options - first 3 in buttons, rest in dropdown
  const hennaServicesMain = ["Henna Designs", "Arabic Henna", "Foot Henna"];
  const hennaServicesAdditional = [
    "Henna", "Mehendi", "Bridal Henna", "Party Henna",
    "Festival Henna", "Hand Henna", "Simple Henna", "Designer Henna"
  ];

  // Makeup services options - all in dropdown (no main buttons in image)
  const makeupServicesOptions = [
    "Bridal Makeup", "Party / Event Makeup", "HD / Airbrush Makeup",
    "Photoshoot Makeup", "Eye & Lip Makeup", "Contouring & Highlighting"
  ];

  // Skin care services options - first 3 in buttons, rest in dropdown
  const skinCareServicesMain = ["Facial Treatments", "Waxing", "Threading"];
  const skinCareServicesAdditional = [
    "Skin Treatments (Acne, Pigmentation)", "Peel & Rejuvenation", "Hand & Foot Care"
  ];

  // Nail services options - first 3 in buttons, rest in dropdown
  const nailServicesMain = ["Manicure", "Pedicure", "Nail Art"];
  const nailServicesAdditional = [
    "Gel / Acrylic Nails", "Nail Extensions & Repair"
  ];

  // Hair services options - first 3 in buttons, rest in dropdown
  const hairServicesMain = ["Haircut", "Hair Coloring", "Hair Spa"];
  const hairServicesAdditional = [
    "Highlights / Balayage", "Hair Treatments", "Styling & Blow Dry",
    "Straightening / Curling / Perm", "Extensions & Wig Styling", "Scalp Care & Consultation"
  ];

  // Massage/Spa services options - first 3 in buttons, rest in dropdown
  const massageSpaServicesMain = ["Body Massage", "Head Massage", "Aromatherapy"];
  const massageSpaServicesAdditional = [
    "Swedish / Deep Tissue", "Thai / Hot Stone", "Head / Foot Massage",
    "Relaxation & Detox"
  ];

  // Other/Trending services options - all in dropdown (no main buttons in image)
  const otherTrendingServicesOptions = [
    "Eyebrow & Eyelash Services", "Laser / IPL Hair Removal", "Tattoos & Body Art",
    "Men's Grooming", "Reiki / Meditation / Yoga"
  ];

  // State for dropdown values
  const [selectedMakeupService, setSelectedMakeupService] = useState('');
  const [selectedOtherTrendingService, setSelectedOtherTrendingService] = useState('');

  return (
    <>
      {/* Beautician Mode */}
      <div className="mb-5">
        <h4 className="mb-3" style={{ color: "black" }}>Beautician Mode *</h4>
        <Row className="g-3">
          {beauticianModes.map((mode, idx) => (
            <Col xs={6} sm={6} md={4} key={idx}>
              <Button
                variant="light"
                className={`language-btn jobtype-btn w-100 ${formData.beautician_mode === mode ? 'selected-button' : ''}`}
                onClick={() => updateField('beautician_mode', mode)}
              >
                {mode}
              </Button>
            </Col>
          ))}
        </Row>
      </div>

      {/* Beautician Type / Specialization */}
      <div className="mb-5">
        <h4 className="mb-3" style={{ color: "black" }}>Beautician Type / Specialization *</h4>
        <Row className="g-3">
          {beauticianSpecializationsMain.map((type, idx) => (
            <Col xs={6} sm={6} md={4} key={idx}>
              <Button
                variant="light"
                className={`language-btn jobtype-btn w-100 ${formData.beautician_type === type ? 'selected-button' : ''}`}
                onClick={() => updateField('beautician_type', type)}
              >
                {type}
              </Button>
            </Col>
          ))}
        </Row>

        <div className="mt-3">
          {/* <h5 className="mb-2">Select other option here</h5> */}
          <CustomDropdown
            title="Select additional specialization"
            field="beautician_type"
            options={beauticianSpecializationsAdditional}
            selectedValue={formData.beautician_type}
            onSelect={updateField}
            required={true}
            menuClassName="personalinfo-nationality-menu"
          />
          {/* <p className="note-text mt-2 mb-3">
            <strong>Note:</strong> Put this point in (Beautician Type / Specialization) drop box option: 
            Manicure / Pedicure Specialist, Facial / Skin Specialist, Massage Therapist, Nail Artist, Eyelash / Eyebrow Specialist, Spa Therapist
          </p> */}
        </div>
      </div>

      {/* Henna Services */}
      {/* Henna Services */}
      <div className="mb-5">
        <h4 className="mb-3" style={{ color: "black" }}>Henna Services</h4>
        <Row className="g-3">
          {hennaServicesMain.map((service, idx) => (
            <Col xs={6} sm={6} md={4} key={idx}>
              <Button
                variant="light"
                className={`language-btn jobtype-btn w-100 ${formData.henna_services?.includes(service) ? 'selected-button' : ''}`}
                onClick={() => toggleHennaServices(service)}
              >
                {service}
              </Button>
            </Col>
          ))}
        </Row>

        <div className="mt-3">
          <CustomDropdown
            title="Select additional henna service"
            field="henna_services"
            options={hennaServicesAdditional}
            selectedValue={formData.henna_services?.[formData.henna_services.length - 1] || ""}
            onSelect={(field, value) => {
              if (value && !formData.henna_services?.includes(value)) {
                toggleHennaServices(value);
              }
            }}
            menuClassName="personalinfo-nationality-menu"
          />
        </div>

        {/* ADD THIS SECTION to display selected values */}
        {formData.henna_services && formData.henna_services.length > 0 && (
          <div className="mt-3">
            <h6 className="mb-2">Selected Henna Services:</h6>
            <div className="d-flex flex-wrap gap-2">
              {formData.henna_services.map((service, idx) => (
                <div key={idx} className="badge bg-primary d-flex align-items-center">
                  {service}
                  <button
                    type="button"
                    className="btn-close btn-close-white ms-2"
                    style={{ fontSize: '0.5rem' }}
                    onClick={() => toggleHennaServices(service)}
                    aria-label="Remove"
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Makeup Services */}
      {/* Makeup Services */}
      <div className="mb-5">
        <h4 className="mb-3" style={{ color: "black" }}>Makeup Services</h4>

        <div className="mt-3">
          <CustomDropdown
            title="Select makeup service"
            field="makeup_services"
            options={makeupServicesOptions}
            selectedValue={formData.makeup_services?.[formData.makeup_services.length - 1] || ""}
            onSelect={(field, value) => {
              if (value && !formData.makeup_services?.includes(value)) {
                toggleMakeupServices(value);
              }
            }}
            menuClassName="personalinfo-nationality-menu"
          />
        </div>

        {/* ADD THIS SECTION to display selected values */}
        {formData.makeup_services && formData.makeup_services.length > 0 && (
          <div className="mt-3">
            <h6 className="mb-2">Selected Makeup Services:</h6>
            <div className="d-flex flex-wrap gap-2">
              {formData.makeup_services.map((service, idx) => (
                <div key={idx} className="badge bg-primary d-flex align-items-center">
                  {service}
                  <button
                    type="button"
                    className="btn-close btn-close-white ms-2"
                    style={{ fontSize: '0.5rem' }}
                    onClick={() => toggleMakeupServices(service)}
                    aria-label="Remove"
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Skin Care Services */}
      {/* Skin Care Services */}
      {/* Skin Care Services */}
      <div className="mb-5">
        <h4 className="mb-3" style={{ color: "black" }}>Skin Care Services</h4>
        <Row className="g-3">
          {skinCareServicesMain.map((service, idx) => (
            <Col xs={6} sm={6} md={4} key={idx}>
              <Button
                variant="light"
                className={`language-btn jobtype-btn w-100 ${formData.skin_care_services?.includes(service) ? 'selected-button' : ''}`}
                onClick={() => toggleSkinCareServices(service)}
              >
                {service}
              </Button>
            </Col>
          ))}
        </Row>

        <div className="mt-3">
          <CustomDropdown
            title="Select additional skin care service"
            field="skin_care_services"
            options={skinCareServicesAdditional}
            selectedValue={formData.skin_care_services?.[formData.skin_care_services.length - 1] || ""}
            onSelect={(field, value) => {
              if (value && !formData.skin_care_services?.includes(value)) {
                toggleSkinCareServices(value);
              }
            }}
            menuClassName="personalinfo-nationality-menu"
          />
        </div>

        {/* ADD THIS SECTION to display selected values */}
        {formData.skin_care_services && formData.skin_care_services.length > 0 && (
          <div className="mt-3">
            <h6 className="mb-2">Selected Skin Care Services:</h6>
            <div className="d-flex flex-wrap gap-2">
              {formData.skin_care_services.map((service, idx) => (
                <div key={idx} className="badge bg-primary d-flex align-items-center">
                  {service}
                  <button
                    type="button"
                    className="btn-close btn-close-white ms-2"
                    style={{ fontSize: '0.5rem' }}
                    onClick={() => toggleSkinCareServices(service)}
                    aria-label="Remove"
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Nail Services */}
      {/* Nail Services */}
      <div className="mb-5">
        <h4 className="mb-3" style={{ color: "black" }}>Nail Services</h4>
        <Row className="g-3">
          {nailServicesMain.map((service, idx) => (
            <Col xs={6} sm={6} md={4} key={idx}>
              <Button
                variant="light"
                className={`language-btn jobtype-btn w-100 ${formData.nail_services?.includes(service) ? 'selected-button' : ''}`}
                onClick={() => toggleNailServices(service)}
              >
                {service}
              </Button>
            </Col>
          ))}
        </Row>

        <div className="mt-3">
          <CustomDropdown
            title="Select additional nail service"
            field="nail_services"
            options={nailServicesAdditional}
            selectedValue={formData.nail_services?.[formData.nail_services.length - 1] || ""}
            onSelect={(field, value) => {
              if (value && !formData.nail_services?.includes(value)) {
                toggleNailServices(value);
              }
            }}
            menuClassName="personalinfo-nationality-menu"
          />
        </div>

        {/* ADD THIS SECTION to display selected values */}
        {formData.nail_services && formData.nail_services.length > 0 && (
          <div className="mt-3">
            <h6 className="mb-2">Selected Nail Services:</h6>
            <div className="d-flex flex-wrap gap-2">
              {formData.nail_services.map((service, idx) => (
                <div key={idx} className="badge bg-primary d-flex align-items-center">
                  {service}
                  <button
                    type="button"
                    className="btn-close btn-close-white ms-2"
                    style={{ fontSize: '0.5rem' }}
                    onClick={() => toggleNailServices(service)}
                    aria-label="Remove"
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Hair Services */}
      {/* Hair Services */}
      <div className="mb-5">
        <h4 className="mb-3" style={{ color: "black" }}>Hair Services</h4>
        <Row className="g-3">
          {hairServicesMain.map((service, idx) => (
            <Col xs={6} sm={6} md={4} key={idx}>
              <Button
                variant="light"
                className={`language-btn jobtype-btn w-100 ${formData.hair_services?.includes(service) ? 'selected-button' : ''}`}
                onClick={() => toggleHairServices(service)}
              >
                {service}
              </Button>
            </Col>
          ))}
        </Row>

        <div className="mt-3">
          <CustomDropdown
            title="Select additional hair service"
            field="hair_services"
            options={hairServicesAdditional}
            selectedValue={formData.hair_services?.[formData.hair_services.length - 1] || ""}
            onSelect={(field, value) => {
              if (value && !formData.hair_services?.includes(value)) {
                toggleHairServices(value);
              }
            }}
            menuClassName="personalinfo-nationality-menu"
          />
        </div>

        {/* ADD THIS SECTION to display selected values */}
        {formData.hair_services && formData.hair_services.length > 0 && (
          <div className="mt-3">
            <h6 className="mb-2">Selected Hair Services:</h6>
            <div className="d-flex flex-wrap gap-2">
              {formData.hair_services.map((service, idx) => (
                <div key={idx} className="badge bg-primary d-flex align-items-center">
                  {service}
                  <button
                    type="button"
                    className="btn-close btn-close-white ms-2"
                    style={{ fontSize: '0.5rem' }}
                    onClick={() => toggleHairServices(service)}
                    aria-label="Remove"
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Massage / Spa Services */}
      {/* Massage / Spa Services */}
      <div className="mb-5">
        <h4 className="mb-3" style={{ color: "black" }}>Massage / Spa Services</h4>
        <Row className="g-3">
          {massageSpaServicesMain.map((service, idx) => (
            <Col xs={6} sm={6} md={4} key={idx}>
              <Button
                variant="light"
                className={`language-btn jobtype-btn w-100 ${formData.massage_spa_services?.includes(service) ? 'selected-button' : ''}`}
                onClick={() => toggleMassageSpaServices(service)}
              >
                {service}
              </Button>
            </Col>
          ))}
        </Row>

        <div className="mt-3">
          <CustomDropdown
            title="Select additional massage/spa service"
            field="massage_spa_services"
            options={massageSpaServicesAdditional}
            selectedValue={formData.massage_spa_services?.[formData.massage_spa_services.length - 1] || ""}
            onSelect={(field, value) => {
              if (value && !formData.massage_spa_services?.includes(value)) {
                toggleMassageSpaServices(value);
              }
            }}
            menuClassName="personalinfo-nationality-menu"
          />
        </div>

        {/* ADD THIS SECTION to display selected values */}
        {formData.massage_spa_services && formData.massage_spa_services.length > 0 && (
          <div className="mt-3">
            <h6 className="mb-2">Selected Massage/Spa Services:</h6>
            <div className="d-flex flex-wrap gap-2">
              {formData.massage_spa_services.map((service, idx) => (
                <div key={idx} className="badge bg-primary d-flex align-items-center">
                  {service}
                  <button
                    type="button"
                    className="btn-close btn-close-white ms-2"
                    style={{ fontSize: '0.5rem' }}
                    onClick={() => toggleMassageSpaServices(service)}
                    aria-label="Remove"
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Other / Trending Services */}
      {/* Other / Trending Services */}
      <div className="mb-5">
        <h4 className="mb-3" style={{ color: "black" }}>Other / Trending Services</h4>

        <div className="mt-3">
          <CustomDropdown
            title="Select other/trending service"
            field="other_trending_services"
            options={otherTrendingServicesOptions}
            selectedValue={formData.other_trending_services?.[formData.other_trending_services.length - 1] || ""}
            onSelect={(field, value) => {
              if (value && !formData.other_trending_services?.includes(value)) {
                toggleOtherTrendingServices(value);
              }
            }}
            menuClassName="personalinfo-nationality-menu"
          />
        </div>

        {/* ADD THIS SECTION to display selected values */}
        {formData.other_trending_services && formData.other_trending_services.length > 0 && (
          <div className="mt-3">
            <h6 className="mb-2">Selected Other/Trending Services:</h6>
            <div className="d-flex flex-wrap gap-2">
              {formData.other_trending_services.map((service, idx) => (
                <div key={idx} className="badge bg-primary d-flex align-items-center">
                  {service}
                  <button
                    type="button"
                    className="btn-close btn-close-white ms-2"
                    style={{ fontSize: '0.5rem' }}
                    onClick={() => toggleOtherTrendingServices(service)}
                    aria-label="Remove"
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

    </>
  );
}

export default BeauticianFields;